import { createSlice } from "@reduxjs/toolkit";

const qureySlice = createSlice({
  name: "qureySlice",
  initialState: {
    loading: false,
  },
  reducers: {
    qureyRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    qureySuccess(state, action) {
      return {
        loading: false,
        queries: action.payload.allEnquery,
      };
    },
    qureyFail(state, action) {
      return {
        loading: false,
        error: action.payload,
      };
    },
    qureyDeleteRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    qureyDeleteSuccess(state, action) {
      return {
        loading: false,
      };
    },
    qureyDeleteFail(state, action) {
      return {
        loading: false,
        error: action.payload,
      };
    },
  },
});

const { actions, reducer } = qureySlice;

export const {
  qureyFail,
  qureyRequest,
  qureySuccess,
  qureyDeleteRequest,
  qureyDeleteSuccess,
  qureyDeleteFail,
} = actions;

export default reducer;
